import React from "react";
import { useTranslation } from "react-i18next";
import "./Filter.scss";
import { useAppDispatch, useAppSelector } from "store/store";
import { searchSelector, activeFilters, activeMobFilters, updateResetFilter } from "features/search-property/searchproperty.slice";
import useToggle from "hooks/useToggle";
import useWindowSize from "hooks/useWindowSize";
import icondown from "assets/icons/search/icon-down.svg";
import { clearSearchResult } from "features/search-result/searchresult.slice";

const Sort: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { filters, mobFilters } = useAppSelector(searchSelector);
    const [sortToggle, toggleSort] = useToggle();
    const size = useWindowSize();
    const sortFilter = (e: any) => {
        Array.from(document.querySelectorAll('.radio-label')).forEach((el) => el.classList.remove('radio_label_is_checked'));
        updateResetFilter(false);
        if (e.target.classList.contains('radio-label')) {

            const sorby = e.target.dataset.sort;
            if (size.width ? size.width > 1110 : false) {
                let params = { ...filters };
                params['page'] = null;
                params['ordering'] = sorby;
                dispatch(clearSearchResult());
                dispatch(activeFilters(params));
            }
            else {
                e.target.classList.add('radio_label_is_checked');
                let params = { ...mobFilters };
                params['ordering'] = sorby;
                dispatch(activeMobFilters(params));
            }
        }
    }
    return (
        <>
            <li className="refine__section">
                <div className="refine__heading" onClick={toggleSort}>
                    <span className="refine__heading-content">{t('searchResults.sort')}</span>
                    <img src={icondown} className={`chevron ${sortToggle ? 'open' : 'close'}`} alt="chevron"></img>
                    {/* <i className="fa fa-caret-down"></i> */}
                </div>
                <div className={`refine__content sort-filter ${sortToggle ? 'collapsed' : ''}`} >
                    <div className="radio">
                        <input id="radio-1" name="radio" type="radio" />
                        <label htmlFor="radio-1" className="radio-label" data-sort="-is_featured" onClick={(e) => { sortFilter(e) }}>
                             {t('searchResults.featured')}
                        </label>
                    </div>
                    <div className="radio">
                        <input id="radio-2" name="radio" type="radio" />
                        <label htmlFor="radio-2" className="radio-label" data-sort="-created" onClick={(e) => { sortFilter(e) }}>
                             {t('searchResults.new')}
                        </label>
                    </div>
                    <div className="radio">
                        <input id="radio-3" name="radio" type="radio" />
                        <label htmlFor="radio-3" className="radio-label" data-sort="-discount" onClick={(e) => { sortFilter(e) }}>
                             {t('searchResults.dscnthl')}
                        </label>
                    </div>
                    <div className="radio">
                        <input id="radio-4" name="radio" type="radio" />
                        <label htmlFor="radio-4" className="radio-label" data-sort="-rate" onClick={(e) => { sortFilter(e) }}>
                            {t('searchResults.pricehl')}
                        </label>
                    </div>
                    <div className="radio">
                        <input id="radio-5" name="radio" type="radio" />
                        <label htmlFor="radio-5" className="radio-label" data-sort="rate" onClick={(e) => { sortFilter(e) }}>
                            {t('searchResults.pricelh')}
                        </label>
                    </div>
                    {/* <div className="radio">
                        <input id="radio-6" name="radio" type="radio" />
                        <label htmlFor="radio-6" className="radio-label" data-sort="-rating" onClick={(e) => { sortFilter(e) }}>
                            Rating (High - Low)
                        </label>
                    </div>
                    <div className="radio">
                        <input id="radio-7" name="radio" type="radio" />
                        <label htmlFor="radio-7" className="radio-label" data-sort="rating" onClick={(e) => { sortFilter(e) }}>
                            Rating (Low - High)
                        </label>
                    </div> */}
                </div>
            </li>
        </>
    );
};

export default Sort;
